import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NunitoText from "../../components/general/NunitoText";
import ReusableButton from "../../components/general/ReusableButton";
import { getTranslatorAssignments } from "../../functions/getData";
import CompetitionTable from "./CompetitionTable";

export default function TranslatePage() {
  document.title = "Translate";
  const location = useLocation();
  const competitionId = new URLSearchParams(location.search).get("competition_id") || "";
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setPage(1);
  }, [competitionId]);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const query = new URLSearchParams({ page: String(page) });
    if (competitionId) query.set("competition_id", competitionId);

    setLoading(true);
    getTranslatorAssignments(`?${query.toString()}`, controller.signal)
      .then((res) => {
        if (!active) return;
        const rows = Array.isArray(res?.data) ? res.data : [];
        setAssignments(rows);
        setTotal(res?.meta?.total || 0);
        setPageSize(Number(res?.meta?.per_page) || 10);
      })
      .catch((error) => {
        if (error?.name === "AbortError") return;
        if (active) setAssignments([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [page, competitionId]);

  return (
    <Box className="wrapperBox">
      <div className="firstRowContainer dashboardAndSelfBtnDiv">
        <ReusableButton
          text="Dashboard"
          fontSize={14}
          bgColor="#F16774"
          height={36}
          width={125}
          br={18}
          to="/dashboard"
          iconType="home"
        />
        <ChevronRightIcon />
        <ReusableButton
          text="Translate"
          fontSize={14}
          bgColor="#F16774"
          height={36}
          br={18}
        />
      </div>
      <div className="formContainer" style={{ marginTop: 12 }}>
        <NunitoText
          value="Translate"
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
          align="left"
        />
        <NunitoText
          value="Expand a competition to see its grades. Open a grade to translate that collection."
          fontSize={16}
          fontWeight={400}
          color="#707070"
          align="left"
          marginTop={8}
          marginBottom={24}
        />
        <CompetitionTable
          assignments={assignments}
          loading={loading}
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
        />
      </div>
    </Box>
  );
}
